'use strict'

import React from 'react'
import { format } from 'date-fns'
import CustomTooltip from '../../../../_components/CustomTooltip'
import { HISTORY_OPERATION_LABELS, HISTORY_OPERATION_STYLES } from '../extra/types'

/**
 * 長文をセル内で省略し、ホバーで全文をツールチップ表示する
 *
 * @param {Object} props
 * @param {string | number | null | undefined} props.value - 表示値
 * @param {string} [props.className] - Td に付与する追加クラス
 * @returns {JSX.Element}
 */
const EllipsisTd = ({ value, className = '' }) => {
  const str = value == null || value === '' ? '-' : String(value)
  if (str === '-') {
    return <td className={`max-w-0 min-w-0 ${className}`}>-</td>
  }
  return (
    <td className={`max-w-0 min-w-0 ${className}`}>
      <CustomTooltip title={str} placement="top">
        {(ref) => (
          <div ref={ref} className="block w-full min-w-0 truncate py-0.5">
            {str}
          </div>
        )}
      </CustomTooltip>
    </td>
  )
}

/**
 * 変更履歴モーダルコンテンツコンポーネント
 *
 * @param {Object} props
 * @param {Array} props.historyList - 変更履歴データ
 * @returns {JSX.Element}
 */
const HistoryModalContent = ({ historyList }) => {
  const rows = historyList || []

  if (rows.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <p>変更履歴はありません。</p>
      </div>
    )
  }

  return (
    <div className="setting-table is-segment -mb-10" style={{ maxHeight: '500px', overflowY: 'auto' }}>
      <table className="setting-table__table table-fixed w-full form-control">
        <colgroup>
          <col className="w-[200px]" />
          <col className="w-[200px]" />
          <col className="w-[200px]" />
          <col className="w-[100px]" />
          <col className="w-[340px]" />
        </colgroup>
        <thead className="sticky top-0 !z-[39]">
          <tr>
            <th className="base-table-header">日時</th>
            <th className="base-table-header">ユーザー</th>
            <th className="base-table-header">変換表</th>
            <th className="base-table-header">操作</th>
            <th className="base-table-header">詳細</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => {
            const dt = row.HistoryUpdateDateTime
            const dateStr = dt ? format(new Date(dt), 'yyyy/MM/dd HH:mm') : '-'
            const op = row.HistoryOperationType
            const opLabel = HISTORY_OPERATION_LABELS[op] ?? op ?? '-'
            const opStyle = HISTORY_OPERATION_STYLES[op] ?? HISTORY_OPERATION_STYLES.update
            const opClass = op === 'create' ? 'action-add' : op === 'update' ? 'action-update' : 'action-delete'
            return (
              <tr key={index}>
                <td className="max-w-0 min-w-0 whitespace-nowrap">{dateStr}</td>
                <EllipsisTd value={row.HistoryUpdateUserName} />
                <EllipsisTd value={row.HistoryConversionTableName} />
                <td className="max-w-0 min-w-0">
                  <CustomTooltip title={opLabel} placement="top">
                    {(ref) => (
                      <div ref={ref} className="min-w-0 truncate">
                        <span
                          className={opClass}
                          style={{
                            display: 'inline-block',
                            maxWidth: '100%',
                            padding: '2px 8px',
                            borderRadius: 4,
                            fontSize: 11,
                            fontWeight: 600,
                            background: opStyle.bg,
                            color: opStyle.color,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            verticalAlign: 'middle'
                          }}
                        >
                          {opLabel}
                        </span>
                      </div>
                    )}
                  </CustomTooltip>
                </td>
                <EllipsisTd value={row.HistoryDetail} />
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default HistoryModalContent
